const carousel = (data) => {
    let val = "";
    if (data.items) {
        val = `<div class="block-swiperCarouselFixHeight swiper js-swiper-carouselFixHeight">
                    <div class="swiper-wrapper">`;

                        data.items.forEach(item => {
                            let url;
                            url = item.file.url;

                            if (typeof item.file.width !== 'undefined' && item.file.width > 1000 && item.file.url.includes("/st3/")) {
                                url = item.file.url.split("/st3/");
                                url = url[0] + '/st3/1200/' + url[1];
                            }
                            if (typeof item.file.width !== 'undefined' && item.file.width > 1000 && item.file.url.includes("/storage/yandex-zen/")) {
                                url = item.file.url.split("/st3/");
                                url = url[0] + '/storage/yandex-zen/1200/' + url[1];
                            }

                            val += `<div class="swiper-slide">
                                        <div class="block-swiperCarouselFixHeight__item">
                                            <div class="block-swiperCarouselFixHeight__item-img">
                                                <img src="${url}" data-src="${item.file.url}">
                                            </div>
                                        </div>
                                    </div>`;
                        });

        val +=     `</div>
                    <div class="swiper-scrollbar"></div>
                </div>`;
    }
    return val;
}

module.exports = carousel
